/** @fileoverview PrimeReact-style `BlockUI` pending-operation boundary. The parent decides when work blocks interaction; while blocked, children are inert and the shared spinner shows, optionally over the whole screen. Request lifetime stays with the caller. */
import React from 'react';
import { createPortal } from 'react-dom';
import AppSpinner from './AppSpinner';
import './AppControls.css';
export function BlockUI({ blocked, fullScreen, template, children }) {
  const overlay = blocked && <div className={`app-loading-overlay${fullScreen ? ' app-loading-overlay--screen' : ''}`} role="status" aria-label="Loading">{template || <AppSpinner />}</div>;
  return <div className="app-loading-boundary" aria-busy={Boolean(blocked)}>
    <div inert={blocked ? true : undefined}>{children}</div>
    {fullScreen && blocked ? createPortal(overlay, document.body) : overlay}
  </div>;
}
